var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNaturbase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.48,11.606H11.6V10.331h.878a.35.35,0,0,0,0-.7H10.024a.35.35,0,1,0,0,.7H10.9v1.275H5.622V9.5a.21.21,0,0,1,.21-.21H7.926a.211.211,0,0,0,.183-.316S6.466,6.122,6.447,6.092A.058.058,0,0,1,6.494,6h.647a.211.211,0,0,0,.183-.316L5.406,2.363a.211.211,0,0,0-.365,0L3.123,5.686A.21.21,0,0,0,3.305,6h.649A.06.06,0,0,1,4,6.084L2.338,8.971a.21.21,0,0,0,.182.316h2.1a.2.2,0,0,1,.2.2v2.116H3.379a.35.35,0,0,0,0,.7h9.1a.35.35,0,0,0,0-.7Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaturbase);
export default __webpack_public_path__ + "static/media/NATURBASE.f965565a31225580866f5c93da514bbe.svg";
export { ForwardRef as ReactComponent };